"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Text;
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const useStyles = (0, core_1.makeStyles)(() => ({
    uppercase: {
        textTransform: 'uppercase',
    },
    center: {
        textAlign: 'center',
    },
    bold: {
        fontWeight: 'bold',
    },
    italic: {
        fontStyle: 'italic',
    },
    underline: {
        textDecoration: 'underline',
    },
}));
function Text({ as: HtmlTag = 'p', children = ' ', className, uppercase = false, center = false, bold = false, italic = false, underline = false, ...rest }) {
    const classes = useStyles();
    const lowercasedTag = HtmlTag.toLowerCase();
    let typographyVariant = 'body1';
    if (['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(lowercasedTag)) {
        typographyVariant = lowercasedTag;
    }
    else if (['strong', 'span', 'small', 'b', 'i', 'u'].includes(lowercasedTag)) {
        typographyVariant = 'body2';
    }
    return (react_1.default.createElement(Typography_1.default, { variant: typographyVariant, component: lowercasedTag, className: (0, clsx_1.default)({
            [classes.uppercase]: uppercase,
            [classes.center]: center,
            [classes.bold]: bold || ['strong', 'b'].includes(lowercasedTag),
            [classes.italic]: italic || lowercasedTag === 'i',
            [classes.underline]: underline || lowercasedTag === 'u',
        }, className), ...rest }, children));
}
